import React from 'react'

const NotifButton = () => {
    return (
        <div>
            <div className="p-4 rounded-lg bg-button">
                <div className="flex">
                    <img src="notif-active.svg" alt=""></img>
                </div>
            </div>
        </div>
    )
}

export default NotifButton
